import { render, staticRenderFns } from "./image.vue?vue&type=template&id=79cc2952&scoped=true"
import script from "./image.vue?vue&type=script&lang=ts"
export * from "./image.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./image.vue?vue&type=style&index=0&id=79cc2952&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "79cc2952",
  "52ae1055"
  
)

export default component.exports